import Image from 'components/Image';
import { Account } from 'model/IChat';
import React from 'react';
import TimeSlot from 'reusable-components/book-block/BookBlockTimeSelector/TimeSlot';

const CSS = require('./TimeListInput.module.scss');

const IMAGE_OPTIONS = {
  width: 24,
  height: 24,
  zoom: 0.8,
  crop: 'thumb',
  gravity: 'faces',
};

interface TimeListInputProps {
  availableTimes: { time: string; locals: string[] }[];
  selectedTime?: string;
  onTimeChange: (time: string) => void;
  preferredLocal?: Partial<Account>;
  isLocalPicker?: boolean;
}

function categorizeTimes(availableTimes: { time: string; locals: string[] }[]) {
  const morning: { time: string; locals: string[] }[] = [];
  const afternoon: { time: string; locals: string[] }[] = [];
  const evening: { time: string; locals: string[] }[] = [];

  availableTimes.forEach(({ time, locals }) => {
    const [hour] = time.split(':').map(Number);
    if (hour < 12) {
      morning.push({ time, locals });
    } else if (hour < 18) {
      afternoon.push({ time, locals });
    } else {
      evening.push({ time, locals });
    }
  });

  return { morning, afternoon, evening };
}

function TimeListInput({
  availableTimes,
  selectedTime,
  onTimeChange,
  preferredLocal,
  isLocalPicker,
}: TimeListInputProps) {
  const { morning, afternoon, evening } = categorizeTimes(availableTimes);

  const renderSection = (
    label: string,
    times: { time: string; locals: string[] }[],
  ) => {
    if (times.length === 0) return null;

    return (
      <li className={CSS.TimeListSection} data-test-id="TimeListInput">
        <h4 className={CSS.SectionLabel}>{label}</h4>
        <ol className={CSS.TimeSlotSection}>
          {times.map(({ time, locals }) => {
            const isPreferredLocalAvailable = preferredLocal
              ? locals.includes(preferredLocal.id)
              : false;
            return (
              <TimeSlot
                key={time}
                time={time}
                onTimeChange={onTimeChange}
                isPreferredLocalAvailable={isPreferredLocalAvailable}
                isSelected={time === selectedTime}
                disabled={isLocalPicker && !isPreferredLocalAvailable}
              />
            );
          })}
        </ol>
      </li>
    );
  };

  return (
    <>
      <ol className={CSS.TimeList}>
        {renderSection('Morning', morning)}
        {renderSection('Afternoon', afternoon)}
        {renderSection('Evening', evening)}
      </ol>
      {preferredLocal && (
        <div className={CSS.Legend}>
          <span className={CSS.TimeLegend}>
            <Image
              src={preferredLocal.photo}
              width={IMAGE_OPTIONS.width}
              height={IMAGE_OPTIONS.height}
              options={IMAGE_OPTIONS}
              className={CSS.LocalImage}
            />
          </span>
          <span className={CSS.LegendText}>
            {preferredLocal.firstName} is available on these times
          </span>
        </div>
      )}
    </>
  );
}

export default TimeListInput;
